import { render, staticRenderFns } from "./SpaceOverview.vue?vue&type=template&id=0c4a06eb&"
import script from "./SpaceOverview.vue?vue&type=script&lang=js&"
export * from "./SpaceOverview.vue?vue&type=script&lang=js&"
import style0 from "./SpaceOverview.vue?vue&type=style&index=0&id=0c4a06eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QSeparator})
